import "./style.scss";

// MUI
import { InputLabel } from "@mui/material";
import StyledButton from "components/shared/StyledButton";
// Components
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { whiteButton } from "components/TitlesList";
import { Controller, useForm } from "react-hook-form";
// React
import { useTranslation } from "react-i18next";
// Store
import { useAppDispatch } from "store/store";
import { createAnalyticalCode } from "store/titleStore";
import { IAnalyticalCodes } from "store/types";

const textFieldStyles = {
    "&.MuiTextField-root": {
        margin: "auto",
        width: "100%",
        marginBottom: "1rem",
    },
    ".MuiFormHelperText-root": {
        color: "rgb(211, 47, 47)",
    },
};

interface ICreateModal {
    close: () => void;
    onCreate: (name: string) => void;
    companyId: number | undefined;
}

interface submitForm {
    name: string;
}

const CreateAnalyticalCode = ({ close, onCreate, companyId }: ICreateModal) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const defaultValues = {
        name: "",
    };

    const { control, handleSubmit, reset } = useForm({ defaultValues });

    const onSubmit = (data: submitForm) => {
        const req = { companyId: companyId, name: data.name };
        dispatch(createAnalyticalCode(req)).then((resp) => {
            if (resp.meta.requestStatus === "fulfilled") {
                onCreate(data.name);
                close();
            }
        });
    };

    return (
        <div className="new-code-modal">
            <h3>{t("AnalyticalCode.AddModalText")}</h3>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                        <div className="input-group-form" style={{ marginBottom: "1rem" }}>
                            <InputLabel
                                sx={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    fontFamily: "Poppins",
                                    marginLeft: "0.3rem",
                                    marginBottom: "3px",
                                    color: "rgb(131 130 130)",
                                }}
                                htmlFor="name"
                            >
                                {t("AnalyticalCode.AddAnalyticalCode")}
                            </InputLabel>
                            <StyledTextField id="name" sx={textFieldStyles} {...field} />
                        </div>
                    )}
                />
                <div className="code-modal-btns">
                    <StyledButton onClick={() => close()} fullWidth sx={{ ...whiteButton, color: "#ED6E6E" }}>
                        {t("AnalyticalCode.Cancel")}
                    </StyledButton>
                    <StyledButton buttonType="primary" fullWidth onClick={handleSubmit(onSubmit)}>
                        {t("IbanModal.IbanFormSave")}
                    </StyledButton>
                </div>
            </form>
        </div>
    );
};

export default CreateAnalyticalCode;
